import React, { useEffect } from "react"
import StyledProgressBar from "../styles/StyledProgressBar"

const ProgressBar = () => {
  return <StyledProgressBar className="progress-bar"></StyledProgressBar>
}

export default ProgressBar
